/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FontFamilyFromJSON, FontFamilyToJSON } from './FontFamily';
import { TextAlignmentFromJSON, TextAlignmentToJSON } from './TextAlignment';
export function UpdateSiteSectionDocumentRequestSiteSectionDocumentFromJSON(json) {
    return UpdateSiteSectionDocumentRequestSiteSectionDocumentFromJSONTyped(json, false);
}
export function UpdateSiteSectionDocumentRequestSiteSectionDocumentFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        siteSectionId: !exists(json, 'site_section_id') ? undefined : json['site_section_id'],
        sort: !exists(json, 'sort') ? undefined : json['sort'],
        title: !exists(json, 'title') ? undefined : json['title'],
        description: !exists(json, 'description') ? undefined : json['description'],
        presentationText: !exists(json, 'presentation_text') ? undefined : json['presentation_text'],
        descriptionAlignment: !exists(json, 'description_alignment')
            ? undefined
            : TextAlignmentFromJSON(json['description_alignment']),
        descriptionFontFamily: !exists(json, 'description_font_family')
            ? undefined
            : FontFamilyFromJSON(json['description_font_family']),
        descriptionFontSize: !exists(json, 'description_font_size') ? undefined : json['description_font_size'],
        descriptionTextColor: !exists(json, 'description_text_color') ? undefined : json['description_text_color']
    };
}
export function UpdateSiteSectionDocumentRequestSiteSectionDocumentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        site_section_id: value.siteSectionId,
        sort: value.sort,
        title: value.title,
        description: value.description,
        presentation_text: value.presentationText,
        description_alignment: TextAlignmentToJSON(value.descriptionAlignment),
        description_font_family: FontFamilyToJSON(value.descriptionFontFamily),
        description_font_size: value.descriptionFontSize,
        description_text_color: value.descriptionTextColor
    };
}
